import * as React from "react";
import { SVGProps } from "react";
const SvgCalendarArrow = (props: SVGProps<SVGSVGElement>) => <svg width={25} height={19} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19" {...props}><g stroke="currentColor" strokeWidth={1.89} fill="none" fillRule="evenodd"><path d="M.48 9.82h22.68M16.86 1l6.3 8.505-6.3 8.505" /></g></svg>;
export default SvgCalendarArrow;